export default __webpack_public_path__ + "static/media/image_18.854639b7.jpg";